import React from "react";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";

const STACK_RULES = graphql`
  query GCStaffStacksListQuery($slateID: ID!) {
    gcStaffStacks(slateId: $slateID) {
      stackRuleId
      owner
      name
      playersDisplayName
      numLineups
    }
  }
`;

const ADD_STACK_RULE = graphql`
  mutation GCStaffStacksListMutation($input: AddGreenMachineStaffStacksInput!) {
    addGreenMachineStaffStacks(input: $input) {
      success
    }
  }
`;

export default function GCStaffStacksList(props) {
  const data = useLazyLoadQuery(
    STACK_RULES,
    { slateID: props.slateID },
    { fetchPolicy: "network-only" }
  );

  const [addStacks] = useMutation(ADD_STACK_RULE);

  if (data.gcStaffStacks?.length === 0) {
    return <></>;
  }

  return (
    <div className="gm-rules-staff-stacks">
      <div className="gc-staff-stacks-list-container">
        <h3>GC Staff Stacks</h3>
        {data.gcStaffStacks.map((stack) => {
          return (
            <div key={stack.stackRuleId}>
              <p>
                <strong>{stack.name}</strong> in{" "}
                <strong>{stack.numLineups}</strong> lineups.
              </p>
              <button
                onClick={() =>
                  addStacks({
                    variables: {
                      input: {
                        greenMachineSessionId: props.greenMachineSessionID,
                        staffStackIds: [stack.stackRuleId],
                      },
                    },
                    onCompleted: () => {
                      props.reloadStackList(
                        {
                          greenMachineSessionID: props.greenMachineSessionID,
                        },
                        { fetchPolicy: "network-only" }
                      );
                    },
                  })
                }
              >
                Add To My Stacks
              </button>
              <hr />
            </div>
          );
        })}
      </div>
    </div>
  );
}
